import { personsListPath } from '../selectors';

export const selectMembershipServices = (personId: number) => state =>
  state.getIn([...personsListPath, personId, 'services', 'membershipInfo', 'services']);
export const selectMembershipInventories = (personId: number) => state =>
  state.getIn([...personsListPath, personId, 'services', 'membershipInfo', 'inventories']);

export const selectExternalServices = (personId: number) => state =>
  state.getIn([...personsListPath, personId, 'services', 'posInfo', 'services']);
export const selectExternalInventories = (personId: number) => state =>
  state.getIn([...personsListPath, personId, 'services', 'posInfo', 'inventories']);

export const selectFamilyMembersServices = (personId: number) => state =>
  state.getIn([...personsListPath, personId, 'services', 'familyMembershipServices']);

export const selectServicesSectionLoading = (personId: number) => state =>
  state.getIn([...personsListPath, personId, 'servicesLoading']);
